import AsyncStorage from "@react-native-async-storage/async-storage";
import { Platform } from "react-native";

class StorageService {
  async getItem(key: string): Promise<string | null> {
    if (Platform.OS === "web") {
      return localStorage.getItem(key);
    }
    return AsyncStorage.getItem(key);
  }

  async setItem(key: string, value: string): Promise<void> {
    if (Platform.OS === "web") {
      localStorage.setItem(key, value);
      return;
    }
    await AsyncStorage.setItem(key, value);
  }

  async removeItem(key: string): Promise<void> {
    if (Platform.OS === "web") {
      localStorage.removeItem(key);
      return;
    }
    await AsyncStorage.removeItem(key);
  }

  async getAllKeys(): Promise<readonly string[]> {
    if (Platform.OS === "web") {
      return Object.keys(localStorage);
    }
    return AsyncStorage.getAllKeys();
  }

  /** Clear all keys (use for logout / delete data). Web: localStorage.clear(); native: removeItem for each key. */
  async clear(): Promise<void> {
    if (Platform.OS === "web") {
      localStorage.clear();
      return;
    }
    const keys = await AsyncStorage.getAllKeys();
    await AsyncStorage.multiRemove(keys as string[]);
  }
}

export const storage = new StorageService();

